module.exports = __webpack_public_path__ + "images/emoji/arrow_up.ec8c519053bf7102162d.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/arrow_up.png
// module id = eM2Q
// module chunks = 1